module.exports = __webpack_public_path__ + "static/media/t.6e3b4f06.svg";